import { render, staticRenderFns } from "./evaluation_main.vue?vue&type=template&id=5ba34824&scoped=true"
import script from "./evaluation_main.vue?vue&type=script&lang=js"
export * from "./evaluation_main.vue?vue&type=script&lang=js"
import style0 from "./evaluation_main.vue?vue&type=style&index=0&id=5ba34824&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba34824",
  null
  
)

export default component.exports